import { useCallback, type FocusEvent, type PointerEvent } from "react";

import { ensureFloorTypingInputKeyboard } from "./floorSerialScan";

/** Run on pointerdown/focus for floor modal typing fields. No observers ??? those fought the launcher. */
export function useFloorTypingInputHandlers(): {
  onPointerDown: (event: PointerEvent<HTMLInputElement>) => void;
  onFocus: (event: FocusEvent<HTMLInputElement>) => void;
} {
  const reinforce = useCallback((input: HTMLInputElement | null) => {
    if (input == null) return;
    ensureFloorTypingInputKeyboard(input);
  }, []);

  return {
    onPointerDown: (event) => {
      reinforce(event.currentTarget);
      event.currentTarget.focus();
    },
    onFocus: (event) => {
      reinforce(event.currentTarget);
    },
  };
}
